module.exports = __webpack_public_path__ + "img/ReviewDetails_1.0f9bc0e8.png";